import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';

import { Token, User } from './';
import { ErrorService } from '../errors/error.service';

@Injectable()
export class UserService {
  private userUrl = '/api/account';
  public currentUser: User;
  private headers = new Headers();

  constructor(
    private http: Http,
    private err: ErrorService,
  ) {
    this.currentUser = <User>{};
    this.headers.append('Cache-Control', 'no-cache, no-store, must-revalidate');
    this.headers.append('Pragma', 'no-cache');
    this.headers.append('Expires', '0');
  }

  load() {
    return new Promise((resolve, reject) => {
      this.requestUser().catch((error: any): any => {
        resolve(true);
        return Observable.throw(error.json().error || 'Server error');
      }).subscribe((user: User) => {
        this.currentUser = user;
        resolve(true);
      });
    });
  }

  login(): Observable<boolean> {
    return  this.http.get(`${this.userUrl}.json`, { headers: this.headers })
    .map(response => {
      let user = this.extractData(response);
      if (!!user && !!user.wmid) {
        this.currentUser = user;
        return true;
      } else {
        return false;
      }

    }).catch(err => {
      window.location.href = '/users/auth/webmoney';
      return Observable.of(false);
    });
  }

  getTokens(): Observable<Token[]> {
    return this.http.get(`${this.userUrl}/tokens.json`, {headers: this.headers})
    .map(
      response => response.json()['tokens']
    ).catch(this.err.handleError);
  }

  requestUser(): Observable<User> {
    return this.http.get(`${this.userUrl}.json`, { headers: this.headers }).map(this.extractData);
  }

  private extractData(response: Response) {
    let result = response.json();
    return result['user'];
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/services/user.service.ts